import { trackAnalyticsEvent } from '@autone/analytics';
import * as React from 'react';

import type { SidebarSubNavigationItemProps } from '../types/Sidebar.types';

import { SidebarMenuSubButton } from './SidebarMenu';

interface SidebarSubItemProps {
  subItem: SidebarSubNavigationItemProps;
  className?: string;
}
export const SidebarSubItem = ({ subItem, className }: SidebarSubItemProps) => {
  const { onClick, icon: Icon, url, isActive, title } = subItem;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackAnalyticsEvent({
      category: 'sidebar',
      action: 'navigation_sub_item_clicked',
      properties: {
        item: title,
        url,
        has_custom_click: !!onClick,
      },
    });

    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <SidebarMenuSubButton
      asChild
      size="sm"
      isActive={isActive}
      className={className}
    >
      <a href={url} onClick={handleClick} className="flex gap-2 items-center">
        {Icon && <Icon size="sm" />}
        {title}
      </a>
    </SidebarMenuSubButton>
  );
};
